import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AuthService } from 'src/app/modules/_services/auth.service';
import { environment } from 'src/environments/environment';
import { FidelidadeService } from './../../../_services/fidelidade.service';
@Component({
  selector: 'app-tabs-navigation',
  templateUrl: './tabs-navigation.component.html',
  styleUrls: ['./tabs-navigation.component.scss'],
})
export class TabsNavigationComponent implements OnInit {
  exibir: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private fidelidadeService: FidelidadeService) { }

  ngOnInit(): void {
    const paginas: string[] = [
      'saibamais',
      'home',
      'loginredirect',
      'esquecisenha',
      'resetarsenha',
      'atendimento'
    ];

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        for (let i = 0; i < paginas.length; i++) {
          if (url.includes(paginas[i])) {
            this.exibir = false;
            return;
          }
        }
        this.exibir = true;
      }
    });
  }

  desconectar(): void {
    this.authService.LocalStorage.desconectar();
    this.router.navigate(['/']);
  }

  redirecionarPerfil(): void {
    this.router.navigate(['/perfil']);
  }

  redirecionarHome(): void {
    this.router.navigate(['/index']);
  }

  redirecionarEcommerce(): void {

    const urlSF = environment.urlSalesForce;

    this.fidelidadeService.obterMembro().subscribe(
      (membro) => {
        const hashEncode = encodeURIComponent(membro.senha);
        const urlLogin = `${urlSF}default/Loyalty-LoginRedirect?email=${membro.email}&hash=${hashEncode}`;
        window.location.href = urlLogin;
      },
      () => {
        window.location.href = urlSF;
      }
    );
  }
}
